export interface IApiError {
    message: string;
}

export interface IRowsAndTotal<T> {
    data: T[];
    rows: T[];
    total: number;
    cursor?: number;
}

export interface ILocation {
    lat: number;
    lng: number;
}

export enum EConnectorIdentifier {
    CONNECTOR_NUMBER = 'CONNECTOR_NUMBER',
    SHORT_CODE = 'SHORT_CODE',
    ALL = "ALL"
}

export interface ICharge {
    __id: string;
    idTag: string;
    station: any;
    connectorId: number;
    business: any; //IBusiness;
    startAt: string;
    stopAt: string;
    duration: number;
    energy: number;
    status: number; // 0 | 1
    power: number;
    history: IChargeHistory;
    meterValues: IMeterValues;
    priceKW: number;
    priceTotal: number;
    socStart: number;
    socStop: number;
    idleDuration: number;
    idlePrice: number;
    connectorIdentifier?: EConnectorIdentifier;
}

export interface IMeterValues {
    date: string[];
    currentImport: number[];
    currentOffered: number[];
    energyActiveImportRegister: number[];
    powerActiveImport: number[];
    SoC: number[];
    temperature: number[];
    voltage: number[];
    priceKW: number[];
}

export enum IBusinessCurrency {
    USD = 'USD',
    UAH = 'UAH',
    EUR = 'EUR',
    MXN = 'MXN',
    CAD = 'CAD',
}

export interface IChargeHistory {
    power: number[];
    date: string[];
}

export enum EStationPricingOption {
    kwh = 'kwh',
    hour = 'hour',
    free = 'free',
}

export interface IError {
    response: {
        data: any;
    };
}
